import React from "react";

// components
import Request from "../misc/Request";
import Training from "../misc/Training";
import TotalServive from "../misc/TotalServive";
import TotalTraining from "../misc/TotalTraining";
import TotalCompanyUser from "../misc/TotalCompanyUser";
import TotalOpportunity from "../misc/TotalOpportunity";
import PieChart from "../../../component/ui/charts/PieChart";
import BarChart from "../../../component/ui/charts/BarChart";

// state
import { useAppDispatch } from "../../../store";
import { getAuthUser } from "../../../services/apis/auth";

const DashBoard = () => {
  const dispatch = useAppDispatch();
  // const loading = useAppSelector(({ loading }) => loading.loading);

  const onLoad = React.useCallback(async () => {
    getAuthUser(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="pb-12">
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        <TotalServive />

        <TotalTraining />

        <TotalOpportunity />

        <TotalCompanyUser />
      </div>

      <div className="w-full flex flex-col lg:flex-row items-center p-4 bg-white rounded-xl shadow-md mt-4">
        <div className="w-full lg:w-[65%] h-[40vh] border p-2 mr-2">
          <BarChart />
        </div>
        <div className="w-full lg:w-[35%] h-[40vh] p-2">
          <PieChart />
        </div>
      </div>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
        <Request />
        <Training />
      </div>
    </div>
  );
};

export default DashBoard;
